module.exports = __webpack_public_path__ + "static/media/fireworks-illustration.b81b95bb.png";